import { getVoxServiceApi } from '@/core/api/generatedApiClient';
import { INLINE_API_ERROR_OPTIONS } from '@/core/api/requestErrorMode';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { SaveVoxServiceRequest, VoxServiceCatalogResponse } from '@/core/generated/api';

/** Управляет карточками услуг приложения */
export const voxServiceService = {
    /** Загружает карточки и доступные продукты */
    async getCatalog(): Promise<VoxServiceCatalogResponse> {
        try {
            const response = await getVoxServiceApi().getVoxServiceCatalog({}, INLINE_API_ERROR_OPTIONS);

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error, 'inline');
        }
    },

    /** Создаёт или изменяет карточку услуги */
    async save(request: SaveVoxServiceRequest, id?: string): Promise<string> {
        try {
            if (id) {
                await getVoxServiceApi()
                    .updateVoxServiceCard({
                        id,
                        saveVoxServiceRequest: request
                    }, INLINE_API_ERROR_OPTIONS);

                return id;
            }

            const response = await getVoxServiceApi().createVoxServiceCard({ saveVoxServiceRequest: request }, INLINE_API_ERROR_OPTIONS);

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error, 'inline');
        }
    },

    /** Удаляет карточку услуги */
    async remove(id: string, version: string): Promise<void> {
        try {
            await getVoxServiceApi()
                .deleteVoxServiceCard({
                    id,
                    version
                }, INLINE_API_ERROR_OPTIONS);
        } catch (error: unknown) {
            return rethrowHandledApiError(error, 'inline');
        }
    },
};

